module.exports = __webpack_public_path__ + "static/media/LINK-logo.f66b0cf3.png";